import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=99271590&scoped=true&"
import script from "./Finalize.vue?vue&type=script&lang=js&"
export * from "./Finalize.vue?vue&type=script&lang=js&"
import style0 from "./Finalize.vue?vue&type=style&index=0&id=99271590&prod&lang=scss&"
import style1 from "./Finalize.vue?vue&type=style&index=1&id=99271590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99271590",
  null
  
)

export default component.exports